export const ACCEPTED = 'accepted'
export const DENIED = 'denied'
export const HOLD = 'hold'
